import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function PersonCard({ person }) {
  return (
    <Link
      to={`/people/${person.person_id}`}
      className="card-dark block p-6 group"
      data-testid={`person-card-${person.person_id}`}
    >
      <div className="flex items-start gap-4">
        {/* Avatar */}
        <div className="relative w-16 h-16 rounded-full overflow-hidden flex-shrink-0 border border-white/10">
          {person.image_url ? (
            <img src={person.image_url} alt={person.name} className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full bg-white/5 flex items-center justify-center text-white/40 text-xl font-heading">
              {person.name.charAt(0)}
            </div>
          )}
        </div>

        {/* Info */}
        <div className="flex-1 min-w-0">
          <h3 className="font-heading font-semibold text-lg text-white group-hover:text-cyan-400 transition-colors">
            {person.name}
          </h3>
          <p className="text-cyan-400/80 text-sm font-mono mb-2">{person.role}</p>
          <p className="text-white/50 text-sm line-clamp-2">{person.bio}</p>

          {/* Expertise tags */}
          {person.expertise?.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-3">
              {person.expertise.slice(0, 3).map(exp => (
                <span key={exp} className="text-xs font-mono text-white/30 bg-white/5 px-2 py-0.5 rounded-sm">
                  {exp}
                </span>
              ))}
            </div>
          )}
        </div>

        <ArrowRight className="w-5 h-5 text-white/20 group-hover:text-cyan-400 group-hover:translate-x-1 transition-all flex-shrink-0" />
      </div>
    </Link>
  );
}
